import { LayoutMain } from './LayoutMain';
import { LayoutTopBar } from './LayoutTopBar';
import { LayoutBody } from './LayoutBody';
import { LayoutSideBar } from './LayoutSideBar';
import { LayoutList } from './LayoutList';
import { LayoutContent } from './LayoutContent';

const Layout = Object.assign(LayoutMain, {
  TopBar: LayoutTopBar,
  Body: LayoutBody,
  SideBar: LayoutSideBar,
  List: LayoutList,
  Content: LayoutContent,
});

export default Layout;
